export default __webpack_public_path__ + "static/media/notepaper-pen.5f469a80.svg";